<script>
import { iIcon, iTooltip, iTooltipAlignmentMode } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: { iIcon, iTooltip },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: null,
    },
    linkExternalUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      palette,
      iTooltipAlignmentMode,
      infoButtonId: crypto.randomUUID(),
    };
  },
};
</script>

<template>
  <div class="info-icon">
    <i-icon
      :id="`info-icon-${infoButtonId}`"
      symbol="small-question-mark"
      :size="12"
      :colour="palette['light-neutral-80']"
      class="info-help-icon"
      :stroke-width="1.5"
    ></i-icon>
    <i-tooltip
      :target="`#info-icon-` + infoButtonId"
      :title="title"
      :description="description"
      :link-text="linkText"
      :link-external-url="linkExternalUrl"
      :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
    />
  </div>
</template>
